module.exports = __webpack_public_path__ + "static/media/user.129ab51c.png";